<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Especialidades por empresa</h4>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de especialidades"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Especialidades por Empresa">
  <AyudaEspeEmpr />
</Modal>

    <hr>

    <!--  DataTable  -->
    <DataTable
      :data="espeemprs"
      :columns="columnas"
      idField="idEspeEmpr"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="true"
      :mostrarBotonExcel="true"
      mensajeVacio="No hay especialidades por empresa disponibles."
      @refresh="cargarTodos()"
      @create="abrirModalCrear()"
      @edit="row => abrirModalEditar(row.idEspeEmpr)"
      @delete="row => deleteEspeEmpr(row.idEspeEmpr)"
    >
      <!-- Celda: Estado -->
      <template #cell-estado="{ row }">
        <span :class="row.estado === 1 ? 'badge bg-success' : 'badge bg-secondary'">
          {{ getEstadoTexto(row.estado) }}
        </span>
      </template>
    </DataTable>

    <!--  Modal crear / editar  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalEspeEmprLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalEspeEmprLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body form-card">

            <!-- Especialidad -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2">
                  <label class="form-label">Especialidad</label>
                </div>
                <div class="col-10">
                  <select class="form-select" v-model="datoEspeEmpr.idEspecialidad">
                    <option v-for="esp in especialidads"
                            :value="esp.idEspecialidad"
                            :key="esp.idEspecialidad">
                      {{ esp.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Estado -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2">
                  <label class="form-label">Estado</label>
                </div>
                <div class="col-10">
                  <select class="form-select" v-model="datoEspeEmpr.estado">
                    <option :value="1">Activo</option>
                    <option :value="0">Inactivo</option>
                  </select>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button v-if="btnCrear" type="button" class="btn btn-success"
                    @click.prevent="guardarEspeEmpr()">
              <span class="material-symbols-outlined align-middle" style="font-size:20px">save</span>
              Guardar
            </button>
            <button v-if="btnEditar" type="button" class="btn btn-success"
                    @click.prevent="guardarEditEspeEmpr()">
              <span class="material-symbols-outlined align-middle" style="font-size:20px">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout        from '@/components/Layout.vue'
import Footer        from '@/components/Footer.vue'
import AyudaEspeEmpr from '@/views/ayuda/AyudaEspeEmpr.vue'
import DataTable     from '@/components/DataTable.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import api           from '@/services/api'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal          from 'sweetalert'

export default {
  name: 'EspeEmprs',
  components: { Layout, Footer, AyudaEspeEmpr, DataTable },

  data() {
    return {
      espeemprs:     [],
      datoEspeEmpr:  {},
      titulo:        '',
      btnCrear:      false,
      btnEditar:     false,
      modalWindow:   true,
      especialidads: [],
      showModalHelp: false,

      //  Columnas para DataTable
columnas: [
  {
    field: 'especialidadNombre',
    label: 'Nombre',
    filterType: 'select',
    filterOptions: [],
  },
  {
    field: 'estado',
    label: 'Estado',
    filterType: 'select',
    filterOptions: [
      { label: 'Activo',   value: 1 },
      { label: 'Inactivo', value: 0 },
    ],
  },
],
    }
  },

computed: {
  opcionesEspecialidad() {
    const set = new Set(this.espeemprs.map(e => e.especialidadNombre).filter(Boolean))
    return [...set].sort()
  },
},

watch: {
  opcionesEspecialidad(vals) {
    const col = this.columnas.find(c => c.field === 'especialidadNombre')
    if (col) col.filterOptions = vals
  },
},

  mounted() {
    this.cargarTodos()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchEspecialidads()
  },

  methods: {
    getEstadoTexto(estado) {
      return estado === 1 ? 'Activo' : 'Inactivo'
    },

    //  Carga de datos
    cargarTodos() {
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      api.get(`/vwespeemprs/idempresa/${idEmpresa}`)
        .then(response => { this.espeemprs = response.data.reverse() })
        .catch(error   => console.error('Error al obtener especialidades:', error))
    },

    fetchEspecialidads() {
      api.get('/vwespecialidads')
        .then(response => { this.especialidads = response.data })
        .catch(error   => console.error('Error al obtener especialidades:', error))
    },

    //  Validación
    validarForm() {
      return validarForm(
        this.datoEspeEmpr,
        ['idEspecialidad'],
        ['idEmpresa', 'idEspecialidad']
      )
    },

    //  CRUD
    async guardarEspeEmpr() {
      if (this.validarForm() !== 1) return
      try {
        this.datoEspeEmpr.idEmpresa = window.sessionStorage.getItem('idEmpresa')
        await api.post('/espeemprs', this.datoEspeEmpr)
        closeModal('ventanaModal')
        swal('Correcto!', 'Especialidad creada exitosamente!', 'success')
        this.cargarTodos()
      } catch {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },

    async guardarEditEspeEmpr() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/espeemprs', this.datoEspeEmpr)
        closeModal('ventanaModal')
        swal('Correcto!', 'Especialidad actualizada exitosamente!', 'success')
        this.cargarTodos()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    async deleteEspeEmpr(idEspeEmpr) {
      try {
        await api.delete(`/espeemprs/${idEspeEmpr}`)
        this.cargarTodos()
      } catch {
        swal('Error!', 'No se pudo eliminar.', 'error')
      }
    },

    //  Apertura de modal
    abrirModalCrear() {
      this.modalWindow   = true
      this.datoEspeEmpr  = {}
      this.titulo        = 'Crear Especialidad por empresa'
      this.btnCrear      = true
      this.btnEditar     = false
      openModal('ventanaModal')
    },

    abrirModalEditar(idEspeEmpr) {
      this.modalWindow = true
      if (idEspeEmpr) {
        api.get(`/vwespeemprs/${idEspeEmpr}`)
          .then(resp => { this.datoEspeEmpr = resp.data })
      }
      this.titulo    = 'Editar Especialidad por empresa'
      this.btnCrear  = false
      this.btnEditar = true
      openModal('ventanaModal')
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
